var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal",
    {
      attrs: {
        id: "downgrade-warn",
        "show-footer": false,
        "show-title": false,
      },
      on: { cancel: _vm.cancel },
    },
    [
      _c("div", { staticClass: "content" }, [
        _c("div", { staticClass: "upgrade-svg" }, [_c("Warn")], 1),
        _vm._v(" "),
        _c("div", { staticClass: "title" }, [_vm._v("Uyarı")]),
        _vm._v(" "),
        _c("div", { staticClass: "description" }, [_vm._t("default")], 2),
        _vm._v(" "),
        _c("div", { staticClass: "subbutton", on: { click: _vm.goShow } }, [
          _vm._v("Yönlendir"),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }